import { useEffect, useRef } from "react";
import { Phone, AlertTriangle, Info } from "lucide-react";
import { Linkify } from "@/components/site/Linkify";

const TONES = { urgent: "border-clay-dark bg-clay-light", warn: "border-[#B76E00]/40 bg-[#FFF4E5]" };

export const SafetyPanel = ({ kind, panel }) => {
  const ref = useRef(null);
  useEffect(() => {
    ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);
  return (
    <div ref={ref} className={`mt-6 scroll-mt-28 rounded-3xl border-2 p-6 ${TONES[panel.tone]}`} role="region" aria-label={panel.title} aria-live="polite" data-testid={`journey-safety-${kind}-panel`}>
      <div className="flex items-center gap-2"><AlertTriangle className="h-6 w-6 text-clay-dark shrink-0" aria-hidden="true" /><h2 className="text-2xl">{panel.title}</h2></div>
      <p className="mt-3 text-lg font-semibold"><Linkify text={panel.lead} /></p>
      <ul className="mt-3 space-y-1.5 list-disc pl-5">{panel.items.map((s) => <li key={s}><Linkify text={s} /></li>)}</ul>
      <div className="mt-5 flex flex-wrap gap-2">
        {panel.calls.map((c, i) => (
          <a key={c.href} href={c.href} className={i === 0 ? "btn-primary !bg-clay-dark hover:!bg-[#853F2A]" : "btn-secondary"} data-testid={`journey-safety-${kind}-call-${c.href.replace(/\D/g, "")}`}>
            <Phone className="h-5 w-5" aria-hidden="true" />{c.label}
          </a>
        ))}
      </div>
      <p className="mt-4 text-ink-soft"><Linkify text={panel.also} /></p>
    </div>
  );
};

export const SafetyDisclaimer = ({ text }) => (
  <p className="mt-5 flex gap-2 text-sm text-ink-muted" data-testid="journey-safety-disclaimer"><Info className="h-4 w-4 shrink-0 mt-0.5" aria-hidden="true" /><span><Linkify text={text} /></span></p>
);
